import {getVersion} from '../api/generated/endpoints/version/version'

const FE_RELEASE = import.meta.env.VITE_SENTRY_RELEASE || 'unknown'

/**
 * Log FE + BE versions to the browser console once on app load.
 * Best-effort: a BE outage must not break startup, so failures are swallowed.
 */
const logVersions = (): void => {
  console.log(`%c[device-mockup-tool] FE ${FE_RELEASE}`, 'color:#888')
  getVersion()
    .then(({data}) => {
      console.log(`%c[device-mockup-tool] BE ${data.release}`, 'color:#888')
    })
    .catch(() => {
      console.log('%c[device-mockup-tool] BE version unavailable', 'color:#888')
    })
}

export {logVersions}
